import { useCallback, useState } from 'react';
import shieldSettings from 'API/handlers/shieldSettings';
import { useAuthorizationContext } from '../../module/Authorization/AuthorizationContainer';

/**
 * API functions for retrieving data from the 'gfh-shield-settings' API
 */
function useShieldSettingsAPI() {
  const [isDamageProtectionEnabled, setIsDamageProtectionEnabled] =
    useState(false);
  const { state: userData } = useAuthorizationContext();

  const accountId = userData ? userData.accountId : null;

  return {
    isDamageProtectionEnabled,
    fetchIsDamageProtectionEnabled: useCallback(() => {
      if (accountId) {
        return shieldSettings
          .fetchIsDamageProtectionEnabled(accountId)
          .then((response) => {
            setIsDamageProtectionEnabled(response.data.productEnabled);
          })
          .catch((error) => {
            console.warn(error);
            setIsDamageProtectionEnabled(false);
          });
      }
    }, [accountId]),
  };
}

export default useShieldSettingsAPI;
